import React, { useState, useEffect, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import axios from "axios";

const countries = [
    "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Antigua and Barbuda", "Argentina", "Armenia", "Australia", "Austria", "Azerbaijan",
    "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil", "Brunei", "Bulgaria", "Burkina Faso", "Burundi",
    "Cabo Verde", "Cambodia", "Cameroon", "Canada", "Central African Republic", "Chad", "Chile", "China", "Colombia", "Comoros", "Congo", "Costa Rica", "Croatia", "Cuba", "Cyprus", "Czechia",
    "Denmark", "Djibouti", "Dominica", "Dominican Republic",
    "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini", "Ethiopia",
    "Fiji", "Finland", "France",
    "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Greece", "Grenada", "Guatemala", "Guinea", "Guinea-Bissau", "Guyana",
    "Haiti", "Honduras", "Hungary",
    "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Israel", "Italy",
    "Jamaica", "Japan", "Jordan",
    "Kazakhstan", "Kenya", "Kiribati", "Kuwait", "Kyrgyzstan",
    "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg",
    "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Mauritania", "Mauritius", "Mexico", "Micronesia", "Moldova", "Monaco", "Mongolia", "Montenegro", "Morocco", "Mozambique", "Myanmar",
    "Namibia", "Nauru", "Nepal", "Netherlands", "New Zealand", "Nicaragua", "Niger", "Nigeria", "North Korea", "North Macedonia", "Norway",
    "Oman",
    "Pakistan", "Palau", "Palestine", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal",
    "Qatar",
    "Romania", "Russia", "Rwanda",
    "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Korea", "South Sudan", "Spain", "Sri Lanka", "Sudan", "Suriname", "Sweden", "Switzerland", "Syria",
    "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Timor-Leste", "Togo", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Tuvalu",
    "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "Uruguay", "Uzbekistan",
    "Vanuatu", "Vatican City", "Venezuela", "Vietnam",
    "Yemen",
    "Zambia", "Zimbabwe"
];

export default function MarketplaceActionModal({ show, onHide, selectedData, onSuccess, activeTab }) {
    const [view, setView] = useState("selection");
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [generalError, setGeneralError] = useState("");
    const imageUrlsRef = useRef({
        image_1: null,
        image_2: null,
    });
    const [imagePreviews, setImagePreviews] = useState({
        image_1: null,
        image_2: null,
    });

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        country: "",
        vat_id: "",
        address: "",
        payment_date: "",
        payment_message: "",
        unit_price: "",
        image_1: null,
        image_2: null,
    });

    useEffect(() => {
        if (!show) {
            setView("selection");
            setErrors({});
            setGeneralError("");
            setFormData({
                name: "",
                email: "",
                phone: "",
                country: "",
                vat_id: "",
                address: "",
                payment_date: "",
                payment_message: "",
                unit_price: "",
                image_1: null,
                image_2: null,
            });

            Object.entries(imageUrlsRef.current).forEach(([key, url]) => {
                if (url && url.startsWith("blob:")) {
                    URL.revokeObjectURL(url);
                }
                imageUrlsRef.current[key] = null;
            });

            setImagePreviews({
                image_1: null,
                image_2: null,
            });
        }
    }, [show]);

    useEffect(() => {
        return () => {
            Object.values(imageUrlsRef.current).forEach((url) => {
                if (url && url.startsWith("blob:")) {
                    URL.revokeObjectURL(url);
                }
            });
        };
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        const selectedFile = files && files[0] ? files[0] : null;

        setFormData((prev) => ({ ...prev, [name]: selectedFile }));

        if (imageUrlsRef.current[name] && imageUrlsRef.current[name].startsWith("blob:")) {
            URL.revokeObjectURL(imageUrlsRef.current[name]);
        }

        if (selectedFile) {
            const previewUrl = URL.createObjectURL(selectedFile);
            imageUrlsRef.current[name] = previewUrl;
            setImagePreviews((prev) => ({ ...prev, [name]: previewUrl }));
        } else {
            imageUrlsRef.current[name] = null;
            setImagePreviews((prev) => ({ ...prev, [name]: null }));
        }
    };

    const handleMarkSold = async () => {
        setLoading(true);
        setErrors({});
        setGeneralError("");
        const token = localStorage.getItem("authToken");

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/market-placer/product/mark-status`,
                {
                    id: selectedData?.marketplace?.id,
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        Accept: "application/json",
                    },
                }
            );

            if (response.data.success) {
                onSuccess();
                onHide();
            } else {
                setGeneralError(response.data.message || "Failed to update status.");
            }
        } catch (err) {
            if (err.response && err.response.data) {
                if (err.response.data.errors) {
                    setErrors(err.response.data.errors);
                }
                setGeneralError(err.response.data.message || "An error occurred while updating status.");
            } else {
                setGeneralError("Server error. Please try again.");
            }
        } finally {
            setLoading(false);
        }
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setErrors({});
        setGeneralError("");
        const token = localStorage.getItem("authToken");

        const payload = new FormData();
        payload.append("product_marketplace_id", selectedData?.marketplace?.id || "");
        payload.append("product_id", selectedData?.product?.id || "");
        payload.append("name", formData.name);
        payload.append("country", formData.country);
        payload.append("address", formData.address);
        payload.append("vat_id", formData.vat_id);
        payload.append("unit_price", formData.unit_price);

        if (formData.email) {
            payload.append("email", formData.email);
        }
        if (formData.phone) {
            payload.append("phone", formData.phone);
        }
        if (formData.payment_date) {
            payload.append("payment_date", formData.payment_date);
        }
        if (formData.payment_message) {
            payload.append("payment_message", formData.payment_message);
        }
        if (formData.image_1) {
            payload.append("image_1", formData.image_1);
        }
        if (formData.image_2) {
            payload.append("image_2", formData.image_2);
        }

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/market-placer/product/punch-order`,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        Accept: "application/json",
                    },
                }
            );

            if (response.data.success) {
                onSuccess();
                onHide();
            } else {
                setGeneralError(response.data.message || "Action failed. Please try again.");
            }
        } catch (err) {
            if (err.response && err.response.data) {
                if (err.response.data.errors) {
                    setErrors(err.response.data.errors);
                }
                setGeneralError(err.response.data.message || "Validation failed or server error.");
            } else {
                setGeneralError("Server error. Please try again.");
            }
        } finally {
            setLoading(false);
        }
    };

    const renderMarketplaceLink = () => {
        const mp = selectedData?.marketplace;
        if (!mp) return null;

        let fullUrl = mp.reference || "";
        if (mp.type === "id" && mp.base_url) {
            fullUrl = `${mp.base_url}${mp.reference || ""}`;
        }

        if (!fullUrl) return null;

        return (
            <a
                href={fullUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary text-decoration-underline small fw-normal d-inline-block mt-1"
            >
                {fullUrl}
            </a>
        );
    };

    const productImage =
        selectedData?.product?.card_img ||
        selectedData?.product?.first_img;

    const fullImageUrl = productImage ? process.env.REACT_APP_IMG_URL + productImage : null;

    return (
        <Modal show={show} onHide={onHide} size="xl" centered className="marketplace-modal">
            <Modal.Header closeButton className="px-3 px-md-4 pt-3 pt-md-4 pb-3 border-bottom">
                <div className="d-flex align-items-center justify-content-between w-100 pe-2 pe-md-3">
                    <div className="min-w-0">
                        <Modal.Title className="fw-bold mb-0 fs-5">
                            {selectedData?.marketplace?.name || "Marketplace"} Options
                        </Modal.Title>
                        {renderMarketplaceLink()}
                    </div>
                </div>
            </Modal.Header>

            <Modal.Body className="p-3 p-md-4">
                {generalError && (
                    <div className="alert alert-danger mb-4 shadow-sm" role="alert">
                        {generalError}
                    </div>
                )}

                <div className="card border-0 bg-light rounded-3 p-3 mb-4 shadow-sm">
                    <div className="d-flex align-items-center flex-wrap gap-3">
                        {fullImageUrl ? (
                            <img
                                src={fullImageUrl}
                                alt={selectedData?.product?.title || "Product Image"}
                                className="rounded border bg-white object-fit-cover shadow-sm"
                                style={{ width: "70px", height: "70px" }}
                            />
                        ) : (
                            <div
                                className="rounded border bg-white d-flex align-items-center justify-content-center text-muted shadow-sm"
                                style={{ width: "70px", height: "70px", fontSize: "12px" }}
                            >
                                No Image
                            </div>
                        )}
                        <div className="min-w-0 flex-grow-1">
                            <span className="badge bg-secondary mb-1">
                                Code: {selectedData?.product?.product_code || "N/A"}
                            </span>
                            <h5 className="fw-bold text-dark mb-1 text-break">
                                {selectedData?.product?.title || "Product Title"}
                            </h5>
                            <div className="text-muted small">
                                {selectedData?.product?.selling_style && (
                                    <span className="me-3">
                                        Style: <strong>{selectedData?.product?.selling_style}</strong>
                                    </span>
                                )}
                                {selectedData?.product?.sell_price_dollar !== undefined && (
                                    <span>
                                        Price: <strong>${selectedData?.product?.sell_price_dollar}</strong>
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {view === "selection" ? (
                    <div className="d-flex flex-column flex-sm-row justify-content-center align-items-stretch align-items-sm-center gap-3 gap-sm-4 py-3 py-md-4">
                        <button
                            className="btn btn-danger btn-lg px-4 px-md-5 py-3 rounded-3 shadow-sm fw-bold"
                            onClick={handleMarkSold}
                            disabled={loading}
                        >
                            {loading ? "Processing..." : "Mark Status"}
                        </button>

                        {!selectedData?.hidePunchOrder && (
                            <button
                                className="btn btn-primary btn-lg px-4 px-md-5 py-3 rounded-3 shadow-sm fw-bold"
                                onClick={() => setView("form")}
                                disabled={loading}
                            >
                                Punch Order
                            </button>
                        )}
                    </div>
                ) : (
                    <form onSubmit={handleFormSubmit}>
                        <div className="row g-3">
                            <div className="col-md-4">
                                <label className="form-label fw-semibold">
                                    Buyer Name <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    name="name"
                                    placeholder="Enter full name"
                                    className={`form-control ${errors.name ? "is-invalid" : ""}`}
                                    value={formData.name}
                                    onChange={handleInputChange}
                                    required
                                />
                                {errors.name && (
                                    <div className="invalid-feedback">{errors.name[0]}</div>
                                )}
                            </div>

                            <div className="col-md-4">
                                <label className="form-label fw-semibold">
                                    Buyer Phone <span className="text-muted fw-normal">(Optional)</span>
                                </label>
                                <input
                                    type="text"
                                    name="phone"
                                    placeholder="+1234567890"
                                    className={`form-control ${errors.phone ? "is-invalid" : ""}`}
                                    value={formData.phone}
                                    onChange={handleInputChange}
                                />
                                {errors.phone && (
                                    <div className="invalid-feedback">{errors.phone[0]}</div>
                                )}
                            </div>

                            <div className="col-md-4">
                                <label className="form-label fw-semibold">
                                    Country <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    name="country"
                                    list="country-options"
                                    placeholder="Search or select country"
                                    className={`form-control ${errors.country ? "is-invalid" : ""}`}
                                    value={formData.country}
                                    onChange={handleInputChange}
                                    required
                                />
                                <datalist id="country-options">
                                    {countries.map((c, index) => (
                                        <option key={index} value={c} />
                                    ))}
                                </datalist>
                                {errors.country && (
                                    <div className="invalid-feedback">{errors.country[0]}</div>
                                )}
                            </div>

                            <div className="col-md-4">
                                <label className="form-label fw-semibold">
                                    Sell Price $ <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="number"
                                    step="0.01"
                                    min="0"
                                    name="unit_price"
                                    placeholder="Enter unit price"
                                    className={`form-control ${errors.unit_price ? "is-invalid" : ""}`}
                                    value={formData.unit_price}
                                    onChange={handleInputChange}
                                    required
                                />
                                {errors.unit_price && (
                                    <div className="invalid-feedback">{errors.unit_price[0]}</div>
                                )}
                            </div>


                            <div className="col-md-4">
                                <label className="form-label fw-semibold">
                                    Address Picture <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="file"
                                    name="image_1"
                                    className={`form-control ${errors.image_1 ? "is-invalid" : ""}`}
                                    accept="image/jpg,image/jpeg,image/png,image/webp"
                                    onChange={handleFileChange}
                                    required
                                />
                                {imagePreviews.image_1 && (
                                    <div className="mt-2 border rounded p-2 bg-light text-center">
                                        <img
                                            src={imagePreviews.image_1}
                                            alt="Preview 1"
                                            className="img-fluid rounded"
                                            style={{ maxHeight: "180px", objectFit: "contain" }}
                                        />
                                    </div>
                                )}
                                {errors.image_1 && (
                                    <div className="invalid-feedback">{errors.image_1[0]}</div>
                                )}
                            </div>

                            <div className="col-md-4">
                                <label className="form-label fw-semibold">
                                    Earning Picture <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="file"
                                    name="image_2"
                                    className={`form-control ${errors.image_2 ? "is-invalid" : ""}`}
                                    accept="image/jpg,image/jpeg,image/png,image/webp"
                                    onChange={handleFileChange}
                                    required
                                />
                                {imagePreviews.image_2 && (
                                    <div className="mt-2 border rounded p-2 bg-light text-center">
                                        <img
                                            src={imagePreviews.image_2}
                                            alt="Preview 2"
                                            className="img-fluid rounded"
                                            style={{ maxHeight: "180px", objectFit: "contain" }}
                                        />
                                    </div>
                                )}
                                {errors.image_2 && (
                                    <div className="invalid-feedback">{errors.image_2[0]}</div>
                                )}
                            </div>

                            <div className="col-md-12">
                                <label className="form-label fw-semibold">
                                    Address <span className="text-danger">*</span>
                                </label>
                                <textarea
                                    name="address"
                                    placeholder="Enter complete delivery address"
                                    className={`form-control ${errors.address ? "is-invalid" : ""}`}
                                    rows="2"
                                    value={formData.address}
                                    onChange={handleInputChange}
                                    required
                                ></textarea>
                                {errors.address && (
                                    <div className="invalid-feedback">{errors.address[0]}</div>
                                )}
                            </div>

                            <div className="col-md-4">
                                <label className="form-label fw-semibold">
                                    Buyer Email <span className="text-muted fw-normal">(Optional)</span>
                                </label>
                                <input
                                    type="email"
                                    name="email"
                                    placeholder="example@domain.com"
                                    className={`form-control ${errors.email ? "is-invalid" : ""}`}
                                    value={formData.email}
                                    onChange={handleInputChange}
                                />
                                {errors.email && (
                                    <div className="invalid-feedback">{errors.email[0]}</div>
                                )}
                            </div>

                            <div className="col-md-4">
                                <label className="form-label fw-semibold">
                                    Vat Id / tax id 
                                </label>
                                <input
                                    type="text"
                                    name="vat_id"
                                    placeholder="Enter VAT ID or tax ID"
                                    className={`form-control ${errors.vat_id ? "is-invalid" : ""}`}
                                    value={formData.vat_id}
                                    onChange={handleInputChange}
                                />
                                {errors.vat_id && (
                                    <div className="invalid-feedback">{errors.vat_id[0]}</div>
                                )}
                            </div>

                            <div className="col-md-4">
                                <label className="form-label fw-semibold">
                                    Payment Date <span className="text-muted fw-normal">(Optional)</span>
                                </label>
                                <input
                                    type="date"
                                    name="payment_date"
                                    className={`form-control ${errors.payment_date ? "is-invalid" : ""}`}
                                    value={formData.payment_date}
                                    onChange={handleInputChange}
                                />
                                {errors.payment_date && (
                                    <div className="invalid-feedback">{errors.payment_date[0]}</div>
                                )}
                            </div>

                            <div className="col-md-12">
                                <label className="form-label fw-semibold">
                                    Payment Message <span className="text-muted fw-normal">(Optional)</span>
                                </label>
                                <textarea
                                    name="payment_message"
                                    placeholder="Enter payment confirmation or reference details"
                                    className={`form-control ${errors.payment_message ? "is-invalid" : ""}`}
                                    rows="2"
                                    value={formData.payment_message}
                                    onChange={handleInputChange}
                                ></textarea>
                                {errors.payment_message && (
                                    <div className="invalid-feedback">{errors.payment_message[0]}</div>
                                )}
                            </div>
                        </div>

                        <div className="d-flex flex-column-reverse flex-sm-row justify-content-end gap-2 mt-4 pt-3 border-top">
                            <button
                                type="button"
                                className="btn btn-secondary px-4 w-100 w-sm-auto"
                                onClick={() => setView("selection")}
                                disabled={loading}
                            >
                                Back
                            </button>
                            <button type="submit" className="btn btn-success px-4 w-100 w-sm-auto" disabled={loading}>
                                {loading ? "Submitting..." : "Submit Order"}
                            </button>
                        </div>
                    </form>
                )}
            </Modal.Body>
        </Modal>
    );
}